module.exports = __webpack_public_path__ + "static/media/Kyrgyzstan - KG.f7cec088.png";